import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type Props = {
  overlay?: boolean;
  label?: string;
};

const SubjectListSliderSkeleton = ({ overlay, label }: Props) => {
  // Create an array of random widths for skeleton items
  const skeletonItems = [
    { id: "all", width: "w-20" }, // "All Subjects" width
    { id: "a", width: "w-24" },
    { id: "b", width: "w-32" },
    { id: "c", width: "w-28" },
    { id: "d", width: "w-36" },
    { id: "e", width: "w-24" },
  ];

  return (
    <div className="relative w-full">
      <div className={cn("w-full border-b border-gray-200")}>
        {overlay && (
          <>
            <div className="absolute left-0 top-0 w-10 h-full bg-gradient-to-r from-white to-transparent z-10" />
            <div className="absolute right-0 top-0 w-10 h-full bg-gradient-to-l from-white to-transparent z-10" />
          </>
        )}
        {label && (
          <div className="pl-7 mb-3">
            <Skeleton className="h-4 w-24" />
          </div>
        )}
        <div className="flex space-x-2 px-2 overflow-x-hidden">
          {skeletonItems.map((item) => (
            <div key={`subject-skeleton-${item.id}`} className="flex-none p-2">
              <Skeleton className={cn("h-4", item.width, "rounded")} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubjectListSliderSkeleton;
